import axios from "axios";
import jwtDecode from "jwt-decode";
import Swal from "sweetalert2";

export function isAuth() {
  const token = localStorage.getItem("sseccaxds");

  if (!token) {
    return false;
  }

  try {
    const decoded = jwtDecode(token);
    const expirationAccess = decoded.exp; // Biasanya, payload sudah didekode menjadi objek JS
    const current_timeAccess = Math.floor(Date.now() / 1000);

    if (current_timeAccess > expirationAccess) {
      localStorage.removeItem("sseccaxds");
      localStorage.removeItem("hserfercxz");
      return false;
    } else {
      return decoded;
    }
  } catch (error) {
    console.error("Invalid token", error);
    return false;
  }
}

export function accessToken() {
  const token = localStorage.getItem("sseccaxds");
  return token;
}

export function setNewHeaders(response) {
  localStorage.setItem("sseccaxds", response.access);
  localStorage.setItem("hserfercxz", response.refresh);
}

export const Logout = () => {
  localStorage.clear();
  window.location.href = "/";
};
export const LogoutClearLocalStorage = () => {
  localStorage.clear();
};

export const LogoutByAdmin = () => {
  localStorage.clear();
  window.location.href = "/auth-apjii/login";
  // window.location.href = "https://akun.apjii.or.id/";
};

// Request get
export const getData = (
  url,
  params,
  reducers,
  type,
  successCallback,
  failedCallback
) => {
  const { dispatch, redux } = reducers;
  dispatch(
    redux({
      type: type,
      payload: {
        loading: true,
        data: false,
        error: false,
      },
    })
  );

  axios({
    method: "GET",
    url: url + params,
  })
    .then((response) => {
      dispatch(
        redux({
          type: type,
          payload: {
            loading: false,
            data: response.data,
            error: false,
          },
        })
      );
      if (successCallback) {
        successCallback();
      }
    })
    .catch((error) => {
      dispatch(
        redux({
          type: type,
          payload: {
            loading: false,
            data: false,
            error: error.message,
          },
        })
      );
      if (failedCallback) {
        failedCallback();
      }
    });
};

// Request post
export const postData = (
  url,
  data,
  reducers,
  type,
  successCallback,
  failedCallback
) => {
  const { dispatch, redux } = reducers;
  dispatch(
    redux({
      type: type,
      payload: {
        loading: true,
        data: false,
        error: false,
      },
    })
  );

  axios({
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
    },
    url: url,
    timeout: 120000,
    data: data,
  })
    .then((response) => {
      Swal.fire({
        icon: "success",
        title: "Record data has been created",
        customClass: {
          container: "z-[99999]",
        },
        text: response.data.messages,
        showConfirmButton: false,
        timer: 1500,
      });
      dispatch(
        redux({
          type: type,
          payload: {
            loading: false,
            data: response.data,
            error: false,
          },
        })
      );
      if (successCallback) {
        successCallback();
      }
    })
    .catch((error) => {
      if (failedCallback) {
        failedCallback();
      }
      if (error.response.data && error.response.status !== 500) {
        // Jika respons mengandung data objek, tampilkan sebagai daftar
        Swal.fire({
          icon: "error",
          title: "Oops...",
          customClass: {
            container: "z-[99999]",
          },
          html: `
          <div>
            <ul>
              ${(() => {
                const entries = Object.entries(error.response.data);
                return entries
                  .map(([key, value], index) => {
                    if (entries.length === 1) {
                      return `<li>${value}</li>`;
                    } else {
                      return `<li><strong>${key}</strong>: ${value}</li>`;
                    }
                  })
                  .join("");
              })()}
            </ul>
          </div>
        `,
        });
      } else {
        // Jika respons tidak mengandung data objek, tampilkan pesan error langsung
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      }
      dispatch(
        redux({
          type: type,
          payload: {
            loading: false,
            data: false,
            error: error.message,
          },
        })
      );
    });
};

// Request put
export const putData = (url, data, reducers, type, successCallback) => {
  const { dispatch, redux } = reducers;
  dispatch(
    redux({
      type: type,
      payload: {
        loading: true,
        data: false,
        error: false,
      },
    })
  );

  axios({
    method: "PUT",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
    },
    url: url,
    timeout: 120000,
    data: data,
  })
    .then((response) => {
      Swal.fire({
        icon: "success",
        title: "Record data has been updated",
        customClass: {
          container: "z-[99999]",
        },
        text: response.data.messages,
        showConfirmButton: false,
        timer: 1500,
      });
      dispatch(
        redux({
          type: type,
          payload: {
            loading: false,
            data: response.data,
            error: false,
          },
        })
      );
      if (successCallback) {
        successCallback();
      }
    })
    .catch((error) => {
      if (error.response.data && error.response.status !== 500) {
        // Jika respons mengandung data objek, tampilkan sebagai daftar
        Swal.fire({
          icon: "error",
          title: "Oops...",
          customClass: {
            container: "z-[99999]",
          },
          html: `
          <div>
          <ul>
            ${Object.entries(error.response.data)
              .map(
                ([key, value]) => `<li><strong>${key}</strong>: ${value}</li>`
              )
              .join("")}
          </ul>
        </div>
        `,
        });
      } else {
        // Jika respons tidak mengandung data objek, tampilkan pesan error langsung
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      }
      dispatch(
        redux({
          type: type,
          payload: {
            loading: false,
            data: false,
            error: error.message,
          },
        })
      );
    });
};

// Request put
export const patchData = (url, data, reducers, type, successCallback) => {
  const { dispatch, redux } = reducers;
  dispatch(
    redux({
      type: type,
      payload: {
        loading: true,
        data: false,
        error: false,
      },
    })
  );

  axios({
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
    },
    url: url,
    timeout: 120000,
    data: data,
  })
    .then((response) => {
      Swal.fire({
        icon: "success",
        title: "Record data has been updated",
        customClass: {
          container: "z-[99999]",
        },
        text: response.data.messages,
        showConfirmButton: false,
        timer: 1500,
      });
      dispatch(
        redux({
          type: type,
          payload: {
            loading: false,
            data: response.data,
            error: false,
          },
        })
      );
      if (successCallback) {
        successCallback();
      }
    })
    .catch((error) => {
      if (error.response.data && error.response.status !== 500) {
        // Jika respons mengandung data objek, tampilkan sebagai daftar
        Swal.fire({
          icon: "error",
          title: "Oops...",
          customClass: {
            container: "z-[99999]",
          },
          html: `
          <div>
            <ul>
              ${(() => {
                const entries = Object.entries(error.response.data);
                return entries
                  .map(([key, value], index) => {
                    if (entries.length === 1) {
                      return `<li>${value}</li>`;
                    } else {
                      return `<li><strong>${key}</strong>: ${value}</li>`;
                    }
                  })
                  .join("");
              })()}
            </ul>
          </div>
        `,
        });
      } else {
        // Jika respons tidak mengandung data objek, tampilkan pesan error langsung
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      }
      dispatch(
        redux({
          type: type,
          payload: {
            loading: false,
            data: false,
            error: error.message,
          },
        })
      );
    });
};

// Request delete
export const deleteData = (url, reducers, type, successCallback) => {
  const { dispatch, redux } = reducers;
  dispatch(
    redux({
      type: type,
      payload: {
        loading: true,
        data: false,
        error: false,
      },
    })
  );

  Swal.fire({
    title: "Are You Sure?",
    text: "The record will be delete",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#378ecc",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
    customClass: {
      container: "z-[99999]",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      axios({
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        url: url,
        timeout: 120000,
      })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "The record has been removed",
            customClass: {
              container: "z-[99999]",
            },
            text: response.data.messages,
            showConfirmButton: false,
            timer: 1500,
          });
          dispatch(
            redux({
              type: type,
              payload: {
                data: response.data,
              },
            })
          );
          if (successCallback) {
            successCallback();
          }
        })
        .catch((error) => {
          if (error.response.data && error.response.status !== 500) {
            // Jika respons mengandung data objek, tampilkan sebagai daftar
            Swal.fire({
              icon: "error",
              title: "Oops...",
              customClass: {
                container: "z-[99999]",
              },
              html: `
              <div>
              <ul>
                ${Object.entries(error.response.data)
                  .map(([key, value]) => `<li>${value}</li>`)
                  .join("")}
              </ul>
            </div>
            `,
            });
          } else {
            // Jika respons tidak mengandung data objek, tampilkan pesan error langsung
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message,
            });
          }
          dispatch(
            redux({
              type: type,
              payload: {
                data: false,
              },
            })
          );
        });
    }
  });
};
